/**
 * Start downloading images before the component that shows them has rendered, so they are
 * already in the browser cache when it does. Used to hide data-fetch latency: local project
 * thumbnails can be fetched while the CMS request is still in flight.
 */
export function preloadImages(urls: readonly (string | undefined)[]): void {
  urls.forEach((url) => {
    if (!url) return;
    const image = new Image();
    image.decoding = 'async';
    image.src = url;
  });
}
